import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import getIneligibleContactReason from 'sequences-lib/lib/getIneligibleContactReason';
export const NoRecords = 'no_records';
export const getEnrollInSequenceButtonStatus = ({
  objectTypeId,
  objectId,
  contacts,
  eligibilities
}) => {
  let reason = null;
  switch (objectTypeId) {
    case CONTACT_TYPE_ID:
      if (eligibilities && contacts.size > 0 && contacts.first()) {
        reason = getIneligibleContactReason({
          contact: contacts.first(),
          eligibility: eligibilities.get(objectId)
        });
      }
      break;
    default:
      if (contacts.size === 0) {
        // non-contact record does not have any associated contacts
        reason = NoRecords;
      }
      break;
  }
  return reason;
};